<section fxLayout="row" fxLayoutAlign="center start">
  <div fxFlex="300px" class="loginContainer" fxLayout="column" fxLayoutAlign="start center">
    <div fxFlex="60px" fxHide.lt-md></div>
    <h1>Konto verifizieren</h1>
    <p class="text-login">Bitte bestätigen Sie Ihre Email-Adresse über den Link den wir Ihnen gesendet haben. Sobald Sie Ihr Konto bestätigt haben, können Sie die Seite neu laden.</p>
    <p class="text-login">Es kann bis zu 5 Minuten dauern, bis Sie den Link per Email erhalten. Sollten Sie keine E-Mail erhalten haben, klicken Sie bitte
      <a (click)="onSendEmailVerification()">hier</a>. Wir senden Ihnen erneut eine E-Mail zu.
    </p>
    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
      <h4>Sie haben Ihr Konto bereits bestätigt?</h4>
      <button class="button yellow" type="submit" color="primary" (click)="authService.checkEmailVerification()">Los geht's!</button>
    </div>

    <div fxFlex="60px"></div>
    <img src="../../../../../assets/img/semmily-logo-dark.png" width="73"/>
  </div>
</section>
